import { ComponentProps } from "react";
import { CachedStateProvider, IControlledMutator, Nullable } from "sonobello.utilities.react";

import { LocalStorageConfigs, loadFromLocal, saveToLocal } from "../../../utils/LocalStorage";
import AppContextValueProvider from "../../App/Compositions/AppContextValueProvider";
import OnLocationChangeNoteUpdater, { INoteUpdaterProps } from "../Components/OnLocationChangeNoteUpdater";
import ComposedUseUpsertPatientNote from "./ComposedUseUpsertPatientNote";
import PatientNoteContentBuilder, { PatientNoteTagProps } from "./PatientNoteContentBuilder";

const configuredPatientNoteUpdater: React.FC<
  INoteUpdaterProps<PatientNoteTagProps> & IControlledMutator<Nullable<string>>
> = props =>
  OnLocationChangeNoteUpdater({
    ...props,
    noteContentBuilder: PatientNoteContentBuilder,
    useDispatchNoteUpdate: ComposedUseUpsertPatientNote
  });

const contextPropsPatientNoteUpdater: React.FC<IControlledMutator<Nullable<string>>> = AppContextValueProvider<
  INoteUpdaterProps<PatientNoteTagProps>,
  ComponentProps<typeof configuredPatientNoteUpdater>
>({
  Component: configuredPatientNoteUpdater,
  map: ({
    patient,
    defaultCenter,
    reservation,
    disqualifyingReasonsCState,
    medicalConclusions,
    medicalForm,
    savePatientNoteTrigger
  }) => ({
    eventTrigger: savePatientNoteTrigger,
    noteProps: {
      patient: patient,
      center: reservation?.center ?? defaultCenter,
      reservation,
      disqualifyingReasons: disqualifyingReasonsCState || [],
      medicalConclusions,
      medicalForm
    } as PatientNoteTagProps
  })
});

// TODO fix CachedStateProvider, its output type should not have `| null` which forces this type assertion. */
const ComposedPatientNoteUpdater: React.FC = () =>
  CachedStateProvider({
    // TODO, not composed correctly
    defaultValue: "",
    localStoreKey: LocalStorageConfigs.patientNoteContent.key,
    writeCache: (key, value) => saveToLocal(value!, key),
    getCache: key => loadFromLocal<string>(key) ?? "",
    Component: contextPropsPatientNoteUpdater
  });

export default ComposedPatientNoteUpdater;
